import React from "react";
import PropTypes from "prop-types";
import Tab from "./Tab";

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
const P2PTabsBar = (props) => {
	return (
		<div className="P2PDisplayModal_tabBar">
			{props.tabs.map((value, index, array) => (
				<Tab
					key={`p2p_tab_${value.tab_id}`}
					tab={value}
					index={index}
					onSelect={props.selectTab}
					isActive={props.activeTab === index}
					last={index === array.length - 1}
					selected={props.selectedTab === index}
					beforeSelected={props.selectedTab === index + 1}
					canCloseTab={props.canCloseTab}
					closeTab={() => props.closeTab(value.tab_id, props.user)}
					isMonitoringClass={props.isMonitoringClass}
					tabCount={array.length}
				/>
			))}
		</div>
	);
};

P2PTabsBar.propTypes = {
	tabs: PropTypes.array,
	selectTab: PropTypes.func,
	activeTab: PropTypes.number,
	selectedTab: PropTypes.number,
	closeTab: PropTypes.func,
	isMonitoringClass: PropTypes.bool,
	user: PropTypes.object,
	canCloseTab: PropTypes.bool,
};

export default P2PTabsBar;
